<script>
  import {list, schema as getScheam, createRecord, updateRecord, removeRecord} from "../../modules/api-client";
  import Cell from '../crud/cell.svelte';
  import FileDropper from '../crud/file-dropper.svelte';
  import Invoice from './invoice.svelte';
  import {printInvoice} from "../../modules/api-client";
  import {getHtmlInvoiceById, getFile} from "../../modules/api-client";

  export let table = 'invoices';
  export let filter;

  let schema = {};
  let cols = ['number', 'endDate', 'subtotal', 'total', 'file'];
  let rows = [];
  let originalRows = [];
  let rowsIndex = {};
  let newRecord = {};

  function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function refresh() {
    //rows = [...rows];
  }

  function refreshIndex() {
    rowsIndex = rows.reduce((obj, r, i) => ({...obj, [r._id]: i}), {});
  }

  async function configure() {
    schema = await getScheam(table);
    rows = await list(table, filter, {endDate: 1});
    refreshIndex();
    originalRows = clone(rows);
  }

  configure();
  $: filter, configure();

  async function update(record) {
    await updateRecord(table, record._id, record);
    const i = rowsIndex[record._id];
    originalRows[i] = clone(record);
    seeChanges();
  }

  async function remove(row) {
    const index = rowsIndex[row._id];
    if (!row.removing) {
      row.removing = true;
      rows = clone(rows);
      setTimeout(() => {
        console.log('stop removing')
        rows[index].removing = false;
      }, 2000);
    } else {
      await removeRecord(table, row._id);
      rows = [...rows.slice(0, index), ...rows.slice(index + 1)];
      originalRows = [...originalRows.slice(0, index), ...originalRows.slice(index + 1)];
      refreshIndex();
    }
  }

  async function cancel({_id}) {
    const index = rowsIndex[_id];
    rows[index] = clone(originalRows[index]);
  }

  async function print({_id}) {
    const pdf = await printInvoice(_id);
    //const win = window.open();
    //win.document.write('<iframe src="' + `data:application/pdf;base64,${pdf}` + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
  }

  async function create() {
    console.log('creating', newRecord);
    const record = await createRecord(table, newRecord);
    rows = [...rows, record];
    originalRows.push(clone(record));
    newRecord = {};
    refreshIndex();
  }

  function seeChanges() {
    console.log('seeing changes')
    for (const i in rows) {
      rows[i].changed = false;
      for (const col of cols) {
        if (rows[i][col] !== originalRows[i][col]) {
          rows[i].changed = true;
          console.log(col, rows[i][col], 'original', originalRows[i][col]);
        }
      }
    }
    refresh();
  }

  $: rows, seeChanges();

  let showing = {};

  async function showData({_id}) {
    showing = {_id, type: 'data'};
  }

  async function showHtml({_id}) {
    const data = await getHtmlInvoiceById(_id);
    console.log(data);
    showing = {_id, type: 'html', data};
  }

  async function showPdf({_id, file}) {
    const {file: data} = await getFile(file)
    console.log(data)
    showing = {_id, type: 'pdf', data};
  }

  async function downloadPdf(row) {

  }
</script>


<div class="container-fluid">
    <div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary title">{table}</h6>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr class="title">
                        {#each cols as col}
                            <th scope="col">{col}</th>
                        {/each}
                        <th>: )</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each rows as row}
                        <tr class="{row.changed ? 'table-danger' : ''}">
                            <td>
                                <Cell bind:value={row['number']} type={'String'}/>
                            </td>
                            <td>
                                <Cell bind:value={row['endDate']} type={'Date'}/>
                            </td>
                            <td>
                                <Cell bind:value={row['subtotal']} type={'Number'}/>
                            </td>
                            <td>
                                <Cell bind:value={row['total']} type={'Number'}/>
                            </td>
                            <td>
                                <FileDropper bind:value={row['file']}>
                                    <Cell bind:value={row['file']} type={'String'}/>
                                </FileDropper>
                            </td>
                            <td>
                                <a href="javascript:;" on:click={() => update(row)}><i
                                        class="bi bi-check-circle"></i></a>
                                <a href="javascript:;" on:click={() => cancel(row)}><i class="bi bi-x-circle"></i></a>
                                <a href="javascript:;" on:click={() => remove(row)}><i
                                        class="bi {row.removing ? 'bi-exclamation-triangle' : 'bi-dash-circle'}"></i></a>
                                <a href="javascript:;" on:click={() => print(row)}><i class="bi bi-printer"></i></a>
                                <br>
                                <a href="javascript:;" on:click={() => showData(row)}><i class="bi bi-eye"></i></a>
                                <a href="javascript:;" on:click={() => showHtml(row)}><i
                                        class="bi bi-file-earmark-code"></i></a>
                                <a href="javascript:;" on:click={() => showPdf(row)}><i
                                        class="bi bi-file-earmark-pdf"></i></a>
                                <a href="javascript:;" on:click={() => downloadPdf(row)}><i
                                        class="bi bi-cloud-arrow-down"></i></a>
                            </td>
                        </tr>
                        {#if showing._id === row._id && showing.type === 'html'}
                            <tr>
                                <td colspan="{cols.length + 1}">
                                    <iframe class="invoice" srcDoc="{showing.data}"></iframe>
                                </td>
                            </tr>
                        {/if}
                        {#if showing._id === row._id && showing.type === 'data'}
                            <tr>
                                <td colspan="{cols.length + 1}">
                                    <Invoice invoice={row}/>
                                </td>
                            </tr>
                        {/if}
                        {#if showing._id === row._id && showing.type === 'pdf'}
                            <tr>
                                <td colspan="{cols.length + 1}">
                                    <iframe class="invoice" src="{showing.data}"></iframe>
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    <tr class="table-secondary">
                        {#each cols as col}
                            <td>
                                <Cell bind:value={newRecord[col]} type="{schema[col]}"/>
                            </td>
                        {/each}
                        <td><a href="javascript:;" on:click={create}><i class="bi bi-plus-circle"></i></a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- /.container-fluid -->

<style>
    .title {
        text-transform: capitalize;
    }

    .invoice {
        width: 100%;
        height: 55em;
    }
</style>